// Decode common HTML entities that sneak in from translation APIs or data entry.
// Applies repeatedly to handle multi-layer encoding (e.g. &amp;amp; → &amp; → &)
export default function decodeEntities(text) {
  if (!text) return text;
  let prev;
  let result = text;
  do {
    prev = result;
    result = result
      .replace(/&amp;/g, '&')
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&quot;/g, '"')
      .replace(/&#0?39;/g, "'")
      .replace(/&#x([0-9a-fA-F]+);/g, (_, hex) => String.fromCharCode(parseInt(hex, 16)))
      .replace(/&#(\d+);/g, (_, dec) => String.fromCharCode(parseInt(dec, 10)));
  } while (result !== prev);
  return result;
}
